export default __webpack_public_path__ + "static/media/029-strongbox.804429cd.png";